import styled from "styled-components"
import Box from "../Box"

export const ContentBody = styled(Box)`
  width: 100%;
  margin: auto;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  padding: 20px 0 20px 20px;

  @media only screen and (max-width: 550px) {
    flex-direction: column;
    padding: 20px;
  }
`



// WEBPACK FOOTER //
// ./src/components/ContentBody/ContentBody.js